import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/omarova.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonOmarova = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Омарова Перизат Танирбердиевна</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Computer Science, Master of Technical Sciences, PhD
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57211531934'}>
                            <MyText><LinkOutlined /> Scopus (h=4)</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0001-9502-7959'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>НАО «КазНУ имени аль-Фараби», старший преподаватель. Стаж по профилю — 9 лет.</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Научный сотрудник</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов оценки эффективности использования воды и определение зон с разными уровнями риска;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Численное моделирование течения, переноса осадков и изменений береговой линии.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    PhD по специальности 6D075100 «Информатика, вычислительная техника и управление» по теме «Разработка модели переноса осадочных пород для прогнозирования загрязнения и заиливания в речных каналах». Навыки: Ansys Fluent, Deep Learning, AutoCAD. Опыт математического и гидродинамического моделирования физических процессов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - «Разработка методов и геоинформационных технологий контроля процессов опустынивания» (2015).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - «Облачная ИВС для автоматизированной генерации химических моделей горения топлив» (2016), мнс.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - «Моделирование паводковых и прорывных волн при прорыве плотины» (2021-2023), мнс.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - «Параллельные алгоритмы для численного моделирования распространения примесей» (2022-2024), руководитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Amirgaliyev, Merembayev, Omarova. Mathematical Modeling of Water Movement During a Dam Break Using the VOF Method. Scientific Journal of Astana IT University, 14, 2023.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Issakhov, Abylkassymova, Omarova. Influence of thermal effects to pollutant dispersion in idealized street canyon. Environmental Science and Pollution Research, 30(12), 2023.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. Omarova, Amirgaliyev, Kozbakova, Ataniyazova. Application of Physics-Informed Neural Networks to River Silting Simulation. Applied Sciences, 13(21), 2023.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    4. Urmashev, Omarova, Merembayev, Amirgaliyev. Modeling Siltation of River Channels Using the Physics-Informed Neural Networks Method. Engineered Science, 33, 2025.
                </MyText>
            </Flex>
        </Flex>
    );
};
